import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery, baseUrl } from "./crmAPI";

const getToken = () => {
    return JSON.parse(localStorage.getItem("token"));
};

export const noLoadingReqAPI = createApi({
    reducerPath: "noLoadingReqAPI",
    baseQuery: axiosBaseQuery({
        baseUrl: baseUrl,
    }),
    endpoints: (builder) => ({
        getPageUnload: builder.query({
            query: (url) => ({ url: url, method: "get" }),
        }),
    }),
});

export const { useGetPageUnloadQuery } = noLoadingReqAPI;
